<template>
    <FormInput :dati='info'
               :file_key='file_key'
               :formlabel="label"
               :stilestruttura="style"
               :idform="idform"
               :action="action"
               :recaptcha="recaptcha"
               ref="input">
    </FormInput>
    <hr class="mt-4 mb-4"/>
    <p class="titolo-tabs mb-4">{{ $root.trans.impostazioni_notifiche_giorni_orari }}</p>
    <div class="notification-calendar">
        <div v-for="(gg, index) in giorni_notifiche" :key="index" class="grid grid-cols-1 gap-4 mb-4">
            <div class="flex flex-col gap-2 w-full">
                <label :for="key" class="text-sm font-semibold label-form">
                    {{ $root.trans.giorno }} <span>*</span>
                </label>

                <Select v-model="giorni_notifiche[index].giorno"
                        :options="getGiorniDisponibili(index)"
                        :name="key"
                        optionLabel="nome"
                        optionValue="id"
                        placeholder="seleziona un giorno"
                        class="form-input w-full"
                        :invalid="validationErrors[`giorno_${index}`]"/>
                <Message v-if="validationErrors[`giorno_${index}`]" severity="error" size="small" variant="simple">
                    {{ validationErrors[`giorno_${index}`] }}
                </Message>
            </div>
            <div v-for="(h, i) in giorni_notifiche[index].orari" :key="i" class="flex items-center gap-2">

                <div class="flex flex-col gap-2 w-full">
                    <label class="text-sm font-semibold label-form">
                        {{ $root.trans.ore }}<span>*</span>
                    </label>
                    <DatePicker v-model="giorni_notifiche[index].orari[i]"
                                timeOnly
                                showIcon
                                fluid
                                :showOnFocus="false"
                                dateFormat="HH:mm"
                                hourFormat="24"
                                :name="key"
                                :invalid="validationErrors[`orario_${index}_${i}`]"
                                :locale="$root.trans"/>

                    <Message v-if="validationErrors[`orario_${index}_${i}`]" severity="error" size="small"
                             variant="simple">
                        {{ validationErrors[`orario_${index}_${i}`] }}
                    </Message>
                </div>

                <Button v-if="giorni_notifiche[index].orari.length > 1"
                        icon="pi pi-times"
                        severity="danger"
                        text
                        rounded
                        size="small"
                      class=" !text-red-600 rimuovi-orario"
                        @click="rimuoviOrario(index, i)"
                        aria-label="Rimuovi orario"/>
            </div>
          <Button class="aggiungi-orario" v-if="giorni_notifiche[index]?.orari?.length < 4" @click="giorni_notifiche[index].orari.push('')">
                {{ $root.trans.aggiungi_orario }}
            </Button>
          <Button class="rimuovi-giorno"  @click="rimuoviGiorno(index)">
                {{ $root.trans.rimuovi_giorno }}
            </Button>

      </div>
      <div>
          <Button v-if="giorni_notifiche.length < 7" @click="aggiungiGiorno" class="aggiungi-giorno">
              {{  $root.trans.aggiungi_giorni_notifiche }}
          </Button>
        </div>
    </div>
    <Message v-if="validationErrors.generale" severity="error" class="mb-4">
        {{ validationErrors.generale }}
    </Message>

    <div v-if="!hideButtons" class="text-right">
        <div class="text-right">
            <a v-if="cancel !== ''" type="button" class="p-button p-component p-button-secondary"
               :href="cancel">{{ bottoneannulla }}</a>
        <button @click="salvaImpostazioniGeneriche" class="salva-button">
            <span class="p-button-label"> <i class="pi pi-save"></i> {{ bottonesalva }}</span>
            </button>
        </div>
    </div>
</template>

<script>


import FormInput from './FormInput.vue';
import {Select, DatePicker, Button, Message} from 'primevue';

export default {
    name: "SingleForm",
    components: {
        FormInput,
        Select,
        DatePicker,
        Button,
        Message
    },
    props: [
        'dati',
        'file_key',
        'hideButtons',
        'struttura',
        'azione',
        'annulla',
        'stilestruttura',
        'id',
        'recaptcha',
        'bottonesalva',
        'bottonesalvacontinua',
        'bottoneannulla'
    ],
    data() {
        return {
            cancel: this.annulla,
            action: this.azione,
            info: (this.dati !== undefined) ? JSON.parse(this.dati) : [],
            file_key: this.file_key,
            label: JSON.parse(this.struttura),
            style: this.stilestruttura,
            //giorni_notifiche: (this.dati !== undefined) ? JSON.parse(JSON.parse(this.dati).giorni_notifiche) : [],
            giorni_notifiche: [],
            errors: {},
            validationErrors: {},
            imginput: false,
            idform: this.id,
            giorni: [
                {id: 0, nome: '--Seleziona un giorno--'},
                {id: 1, nome: 'Lunedì'},
                {id: 2, nome: 'Martedì'},
                {id: 3, nome: 'Mercoledì'},
                {id: 4, nome: 'Giovedì'},
                {id: 5, nome: 'Venerdì'},
                {id: 6, nome: 'Sabato'},
                {id: 7, nome: 'Domenica'},
            ]
        };
    },
    beforeMount() {

        if (typeof this.id == "undefined") {
            this.idform = 'maschera';
        } else {
            this.idform = this.id;
        }
        this.giorni_notifiche = JSON.parse(this.info.giorni_notifiche || '[]');
        this.giorni_notifiche = this.giorni_notifiche.map(g => ({
            giorno: g.giorno,
            orari: g.orari.map(o => o ? new Date(`1970-01-01T${o}:00`) : '')
        }));
    },
    mounted() {
        const thiz = this
        document.addEventListener('formChanged', function (e) {
            if (e.detail.newStruttura) {
                thiz.updateStruttura(e.detail.newStruttura)
            }

            if (e.detail.newData) {
                thiz.updateData(e.detail.newData)
            }
        });
    },
    methods: {
        updateStruttura: function (newStruttura) {
            // Aggiorna la label nel componente FormInput direttamente
            this.label = newStruttura;
            this.$refs.input.label = newStruttura;
            // Forza il re-render del componente
            this.$refs.input.$forceUpdate();
        },
        updateData: function (newData) {
            this.$refs["input"].info = newData;
            console.log(this.$refs["input"].info, newData)
        },
        validate: function (tipo) {
            return this.$refs.input.checkForm(tipo)
        },
        getGiorniDisponibili: function (currentIndex) {
            const giorniSelezionati = this.giorni_notifiche
                .map((g, idx) => idx !== currentIndex ? g.giorno : null)
                .filter(g => g !== null && g !== 0);

            return this.giorni.filter(g => {
                return g.id === 0 || !giorniSelezionati.includes(g.id);
            });
        },
        validateForm: function () {
            this.validationErrors = {};
            let isValid = true;

            // Controlla giorni duplicati
            const giorniUsati = {};
            this.giorni_notifiche.forEach((g, index) => {
                if (g.giorno && g.giorno !== 0) {
                    if (giorniUsati[g.giorno]) {
                        this.validationErrors[`giorno_${index}`] = this.$root.trans.error_giorno_gia_selezionato;
                        isValid = false;
                    }
                    giorniUsati[g.giorno] = true;
                } else {
                    this.validationErrors[`giorno_${index}`] = this.$root.trans.error_seleziona_giorno_valido;
                    isValid = false;
                }

                // Controlla che ci siano orari
                if (!g.orari || g.orari.length === 0 || g.orari.every(o => !o)) {
                    this.validationErrors['generale'] = this.$root.trans.error_almeno_un_orario;
                    isValid = false;
                }

                // Controlla validità orari
                if (g.orari) {
                    console.log(g.orari)
                    g.orari.forEach((orario, i) => {
                        if (orario) {
                            if (isNaN(orario)) this.validationErrors[`orario_${index}_${i}`] = this.$root.trans.error_orario_non_valido;

                            const hours = orario.getHours();
                            const minutes = orario.getMinutes();
                            if (hours < 6 || hours > 22 || (hours === 22 && minutes > 0)) {
                                this.validationErrors[`orario_${index}_${i}`] = this.$root.trans.error_range_orario;
                                isValid = false;
                            }
                        }
                    });
                }
            });


            return isValid;
        },
        aggiungiGiorno: function () {
            this.giorni_notifiche.push({giorno: 0, orari: ['']});
        },
        rimuoviGiorno: function (index) {
            this.giorni_notifiche.splice(index, 1);
            // Pulisci gli errori relativi a questo giorno
            Object.keys(this.validationErrors).forEach(key => {
                if (key.startsWith(`giorno_${index}`) || key.startsWith(`orario_${index}`)) {
                    this.$delete(this.validationErrors, key);
                }
            });
        },
        rimuoviOrario: function (index, i) {
            this.giorni_notifiche[index].orari.splice(i, 1);
            // Pulisci gli errori relativi a questo orario
            Object.keys(this.validationErrors).forEach(key => {
                if (key.startsWith(`orario_${index}_${i}`)) {
                    this.$delete(this.validationErrors, key);
                }
            });
        },
        salvaImpostazioniGeneriche: function () {
            if (!this.validateForm()) {
                return;
            }

            // Pulisci gli orari vuoti
            const giorniPuliti = this.giorni_notifiche.map(g => ({
                giorno: g.giorno,
                orari: g.orari.filter(o => o)
            }));

            this.$refs.input.info.giorni_notifiche = JSON.stringify(giorniPuliti);
            this.$refs.input.checkForm(0);
        }

    }
}


</script>
